// src/features/task/ChipMultiSelect.tsx
// Lightweight multi-select for admin forms — a wrapped list of toggle chips
// fed by an explicit option list (task types, custom field definitions, …).
// Not a native <select multiple>; buttons only, keyboard/focus reachable.

export interface ChipMultiSelectOption {
  value: string;
  label: string;
}

export interface ChipMultiSelectProps {
  options: ChipMultiSelectOption[];
  selected: string[];
  onToggle: (value: string) => void;
  emptyLabel?: string;
  disabled?: boolean;
}

export function ChipMultiSelect({ options, selected, onToggle, emptyLabel, disabled }: ChipMultiSelectProps) {
  if (options.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyLabel}</p>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const isSelected = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            aria-pressed={isSelected}
            onClick={() => onToggle(opt.value)}
            className={`inline-flex items-center px-3 py-1.5 rounded-md text-xs font-medium border transition-colors ${
              isSelected
                ? 'bg-primary text-primary-foreground border-primary'
                : 'bg-background text-muted-foreground border-border hover:border-foreground/20'
            } ${disabled ? 'pointer-events-none opacity-50' : ''}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default ChipMultiSelect;
